var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5789C12 16.4683 13.567 18 15.5 18C17.433 18 19 16.4683 19 14.5789C19 12.6896 17.433 11.1579 15.5 11.1579C13.567 11.1579 12 12.6896 12 14.5789ZM12 14.5789C12 13.8086 12.2605 13.0978 12.7 12.526V6.36842M12 14.5789C12 15.1437 12.14 15.6764 12.3879 16.1459C11.7982 16.6328 10.4361 16.9737 8.85 16.9737C6.7237 16.9737 5 16.361 5 15.6053V6.36842M12.7 6.36842C12.7 7.12418 10.9763 7.73684 8.85 7.73684C6.7237 7.73684 5 7.12418 5 6.36842M12.7 6.36842C12.7 5.61266 10.9763 5 8.85 5C6.7237 5 5 5.61266 5 6.36842M5 12.5263C5 13.2821 6.7237 13.8947 8.85 13.8947C10.3823 13.8947 11.7055 13.5766 12.3252 13.116M12.7 9.44737C12.7 10.2031 10.9763 10.8158 8.85 10.8158C6.7237 10.8158 5 10.2031 5 9.44737",
    stroke: "#01AC50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/income.f3d6f79db58750326db7d9571c8d4833.svg";
export { ForwardRef as ReactComponent };